// react
import React from 'react';

// components
import { Title } from '@/components/atoms/Title/Title';
import { Content } from '@/components/templates/Content/Content';
import { FlexGap } from '@/components/atoms/FlexGap/FlexGap';

// mui
import { Typography, Stack, Container } from '@mui/material';

interface TaskPageTemplateProps {
  topImage?: string;
  title?: string;
  description?: string | React.ReactNode;
  reasons?: React.ReactNode;
  form?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * TaskPage is a page for a single task that the user needs to complete before proceeding.
 */
export const TaskPageTemplate = ({
  topImage,
  title,
  description,
  reasons,
  form,
  maxWidth = 'md',
}: TaskPageTemplateProps) => {
  return (
    <Container maxWidth={maxWidth}>
      <Stack
        sx={{
          alignItems: 'center',
          gap: 4,
        }}
      >
        <Stack
          sx={{
            alignItems: 'center',
            gap: 3,
          }}
        >
          {topImage && <img src={topImage} alt='top image' />}
          <Stack
            sx={{
              alignItems: 'center',
              gap: 1,
            }}
          >
            {title && (
              <Typography variant='h5' align='center'>
                {title}
              </Typography>
            )}
            {!!description && (
              <Typography variant='body2' align='center'>
                {description}
              </Typography>
            )}
          </Stack>
        </Stack>
        {reasons || <></>}
        {form || <></>}
      </Stack>
    </Container>
  );
};

TaskPageTemplate.displayName = 'TaskPageTemplate';

export default TaskPageTemplate;
